// ADR-133 D9: view descriptors for Reports → Ingestion Sync Runs.
//
// Keyed 'PROVIDER:SYNC_TYPE:sectionKey'. A descriptor lists the extra columns
// (first-level fields of the item preview) shown after Label / Email / Source id.
// A section WITHOUT a descriptor renders generically from its preview, so a new
// or renamed section never breaks the page — descriptors only make it nicer.
// `fromVersion` / `toVersion` match the run's resultSchemaVersion (ADR-132 §7.3).

const AMERICAS_EMPLOYEE_ACTION_COLUMNS = [
  { path: 'operation', label: 'Operation' },
  { path: 'contractId', label: 'Contract' },
];

export const INGESTION_SYNC_RUN_VIEWS = {
  'AMERICAS:EMPLOYEES:hired': { columns: AMERICAS_EMPLOYEE_ACTION_COLUMNS },
  'AMERICAS:EMPLOYEES:rehired': { columns: AMERICAS_EMPLOYEE_ACTION_COLUMNS },
  'AMERICAS:EMPLOYEES:resigned': {
    columns: [...AMERICAS_EMPLOYEE_ACTION_COLUMNS, { path: 'cancelledBeforeStart', label: 'Cancelled before start' }],
  },
  'AMERICAS:EMPLOYEES:withdrawn': { columns: AMERICAS_EMPLOYEE_ACTION_COLUMNS },
  'AMERICAS:EMPLOYEES:updated': { columns: AMERICAS_EMPLOYEE_ACTION_COLUMNS },
  'AMERICAS:EMPLOYEES:skipped': { columns: [{ path: 'reason', label: 'Reason' }] },
};

// Keys never shown as generic columns: they already have their own column.
export const GENERIC_COLUMN_EXCLUDED_KEYS = new Set([
  'email', 'normalizedEmail', 'fullName', 'name', 'employeeName', 'sourceEmployeeId', 'radarEmployeeId',
]);

export const GENERIC_COLUMN_LIMIT = 4;
